export enum ModalState {
    ADD = "ADD",
    EDIT = "EDIT",
    SHOW = "SHOW",
    DELETE = "DELETE",
    CONFIRM = "CONFIRM",
    NONE = "NONE"
}
